module.exports = __webpack_public_path__ + "img/ApplicationManager.3cd0d5d9.svg";